<template>
  <section class="product-list">
    <b-tabs size="is-medium">
      <b-tab-item label="匯出科威團型需要資料">
        <section style="min-height: 100px;">
          <b-button
            :loading="onExporting"
            class="is-primary mt-6"
            style="width: 100%"
            @click="onExportForCowell"
          >
            <span>匯出科威團型需要資料</span>
          </b-button>
        </section>
      </b-tab-item>
      <b-tab-item label="匯出指定欄位">
        <nav class="columns">
          <div class="column">
            <b-field grouped group-multiline>
              <b-field>
                <b-select
                  v-model="selectedArea"
                  :loading="loadingAreas"
                  :placeholder="
                    $t('message.please_select') + $t('attributes.area')
                  "
                  @input="onSelectArea"
                >
                  <option value="">
                    {{ $t('attributes.all_area') }}
                  </option>
                  <option
                    v-for="option in areas"
                    :value="option"
                    :key="option.code"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field>
                <b-select
                  v-model="selectedCatalog"
                  :loading="loadingAreas"
                  :disabled="catalogs.length <= 0"
                  :placeholder="
                    $t('message.please_select') + $t('attributes.catalog')
                  "
                  @input="onSelectCatalog"
                >
                  <option value="">全部類別</option>
                  <option
                    v-for="option in catalogs"
                    :value="option"
                    :key="option.catalog_no"
                  >
                    {{ !option.status ? '[下架]' : '' }}
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field>
                <p class="control">
                  <span class="button is-static">
                    {{ $t('attributes.activation_status') }}
                  </span>
                </p>
                <b-select v-model="filterStatus">
                  <option value="">{{ $t('attributes.all') }}</option>
                  <option value="true">{{ $t('attributes.shelve_on') }}</option>
                  <option value="false">
                    {{ $t('attributes.shelve_off') }}
                  </option>
                </b-select>
              </b-field>
              <b-field>
                <p class="control">
                  <span class="button is-static">
                    {{ $t('attributes.product_type') }}
                  </span>
                </p>
                <b-select v-model="filterType">
                  <option value="">{{ $t('attributes.all') }}</option>
                  <option
                    v-for="(type, idx) in productTypes"
                    :key="idx"
                    :value="type.value"
                  >
                    {{ type.name }}
                  </option>
                </b-select>
              </b-field>
            </b-field>
          </div>
          <div class="column is-3 is-2-desktop" style="width: 20%;">
            <div class="buttons is-right"></div>
          </div>
        </nav>
        <section style="min-height: 100px;">
          <div
            style="display: inline-block; font-size: 18px; font-weight: 600;"
          >
            欄位：
          </div>
          <div style="display: inline-block;">
            <b-checkbox
              v-for="field in fields"
              :key="field.key"
              :native-value="field.key"
              v-model="selectedFields"
              class="column is-marginless"
            >
              <p class="has-text-weight-medium" :style="{ color: field.color }">
                {{ field.name }}
              </p>
            </b-checkbox>
          </div>
        </section>
        <section style="min-height: 100px;">
          <b-button
            :loading="onExporting"
            class="is-primary"
            style="width: 100%"
            @click="onExport"
          >
            <span>{{ $t('message.export_reports') }}</span>
          </b-button>
        </section>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { AREA_API, PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'Export',
  data() {
    const productTypes = this.GetProductTypes()
    return {
      productTypes,
      sending: false,
      loadingAreas: false,
      onExporting: false,

      selectedFields: [],
      fields: [
        { key: 'areaName', name: '線別名稱', color: 'black' },
        { key: 'catalogName', name: '分類名稱', color: 'black' },
        { key: 'prodCode', name: '團別代碼', color: 'black' },
        { key: 'prodName', name: '團名', color: 'black' },
        { key: 'depDate', name: '出發日期(逗號分隔)', color: 'black' },
        { key: 'airline', name: '航空公司', color: 'black' }
      ],

      areas: [],
      selectedArea: '',

      catalogs: [],
      selectedCatalog: '',

      filterStatus: true,

      filterType: ''
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.catalogs = []
        this.selectedArea = null
        this.selectedCatalog = null
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null
        this.selectedCatalog = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    onSelectArea(option) {
      this.selectedArea = option
      this.catalogs = option ? option.catalogs.sort(c => c.sort) : []
      this.selectedCatalog = null
    },
    onSelectCatalog(option) {
      this.selectedCatalog = option
    },
    async onExportForCowell() {
      try {
        this.onExporting = true
        const api = `${PRODUCTS_API}/export-cowell`
        const config = {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob'
        }

        const response = await this.axios.put(api, '', config)
        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `products_${date}`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載失敗', e)
      } finally {
        this.onExporting = false
      }
    },
    async onExport() {
      if (this.selectedFields.length <= 0)
        return notifyService.error('錯誤，請至少選擇一個欄位!!')
      try {
        this.onExporting = true
        const api = `${PRODUCTS_API}/export`

        const data = {
          area_code: this.selectedArea ? this.selectedArea.code : '',
          catalog_no: this.selectedCatalog
            ? this.selectedCatalog.catalog_no
            : '',
          status: this.filterStatus,
          type: this.filterType,
          fields: this.selectedFields.join(',')
        }

        const config = {
          headers: { Accept: 'application/vnd.ms-excel' },
          responseType: 'blob'
        }

        const response = await this.axios.put(api, data, config)
        const date = this.$dayjs().format('YYYYMMDDHHmmss')
        const fileName = `products_${date}`

        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        notifyService.error('下載失敗', e)
      } finally {
        this.onExporting = false
      }
    }
  }
}
</script>
